import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {pullRequestsAppBuilder} from '../config/app-builder'
import {FindingsRoutePath} from './route-paths'

export function buildPullRequestsFindingsRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('pullRequestsFindingsRoute', {
    path: FindingsRoutePath,
    queries: [],
  })
}

export const pullRequestsFindingsRoute = buildPullRequestsFindingsRoute(pullRequestsAppBuilder)
